import { createContext, useContext, useState, useEffect } from "react";
import dayjs from "dayjs";

const DateFilterContext = createContext();

export const DateFilterProvider = ({ children }) => {
  // 🔹 Default = last full month
  const defaultStart = dayjs().startOf("month").toDate();
  const defaultEnd = dayjs().endOf("month").toDate();

  const defaultRange = [
    { startDate: defaultStart, endDate: defaultEnd, key: "selection" }
  ];

  const defaultFilters = {
    start: dayjs(defaultStart).format("YYYY-MM-DD"),
    end: dayjs(defaultEnd).format("YYYY-MM-DD")
  };

  // Always start with valid defaults (never [])
  const [dateRange, setDateRange] = useState(defaultRange);
  const [filters, setFilters] = useState(defaultFilters);

  // After mount, try to restore from localStorage
useEffect(() => {
  try {
    const saved = localStorage.getItem("dateRange");
    if (saved) {
      const parsed = JSON.parse(saved);

      if (parsed.start && parsed.end) {
        const restoredRange = [
          {
            startDate: dayjs(parsed.start).toDate(),
            endDate: dayjs(parsed.end).toDate(),
            key: "selection"
          }
        ];
        setDateRange(restoredRange);

        setFilters({
          start: dayjs(parsed.start).format("YYYY-MM-DD"),
          end: dayjs(parsed.end).format("YYYY-MM-DD")
        });
      }
    }
  } catch (err) {
    console.warn("Failed to restore date filter from localStorage:", err);
  }
}, []);


  //  Keep localStorage in sync when dateRange changes
  useEffect(() => {
    if (dateRange?.[0]) {
      localStorage.setItem(
        "dateRange",
        JSON.stringify({
          start: dayjs(dateRange[0].startDate).format("YYYY-MM-DD"),
          end: dayjs(dateRange[0].endDate).format("YYYY-MM-DD")
        })
      );
    }
  }, [dateRange]);

  // Keep localStorage in sync when filters change
  useEffect(() => {
    if (filters) {
      localStorage.setItem("filters", JSON.stringify(filters));
    }
  }, [filters]);

  return (
    <DateFilterContext.Provider
      value={{ dateRange, setDateRange, filters, setFilters }}
    >
      {children}
    </DateFilterContext.Provider>
  );
};

//  Arrow function hook (safe with Vite Fast Refresh)
export const useDateFilter = () => useContext(DateFilterContext);
